import { WebSocketEditNotification, WebSocketEditNotificationElement } from '@agroone/entities'
import { DestroyRef, Directive, ElementRef, OnInit, Renderer2, inject, input } from '@angular/core'
import { combineLatest, map, Observable } from 'rxjs'
import { WebSocketStateService } from '../services'
import { requireDefined } from '../utils/require-defined.util'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Directive({
  selector: '[wsEditing]',
})
export class WebSocketEditingDirective implements OnInit {
  private readonly destroyRef = inject(DestroyRef)

  private el = inject(ElementRef)
  private renderer = inject(Renderer2)
  private webSocketStateService = inject(WebSocketStateService)

  readonly wsEditing = input<{
    elementId: number | null
    elementType: WebSocketEditNotificationElement
    classes: string
    offerId?: number | null
  }>()

  ngOnInit(): void {
    const obs: Observable<WebSocketEditNotification | undefined>[] = []
    const wsEditing = this.wsEditing()
    if (wsEditing?.elementId) {
      obs.push(this.webSocketStateService.isEditing(wsEditing.elementId.toString(), wsEditing.elementType))
    }
    if (wsEditing?.offerId) {
      obs.push(
        this.webSocketStateService.isEditing(
          wsEditing.offerId.toString(),
          WebSocketEditNotificationElement.PLANIFICATION_OFFER,
        ),
      )
    }
    combineLatest(obs)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(([a, b]) => a || b),
      )
      .subscribe((isEditing) => {
        this.updateStyles(!!isEditing)
      })
  }

  private updateStyles(isEditing: boolean | undefined): void {
    const classNames = requireDefined(this.wsEditing(), 'the wsEditing configuration').classes.split(' ')
    if (isEditing) {
      classNames.forEach((className) => {
        this.renderer.addClass(this.el.nativeElement, className)
      })
    } else {
      classNames.forEach((className) => {
        this.renderer.removeClass(this.el.nativeElement, className)
      })
    }
  }
}
